import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { BasicTableTh } from '../../Zemplin/General/Table';
import { TableWrapper } from '../../Zemplin/General/TableWrapper';
import { RequestDetailItemRow } from './RequestDetailItemRow';
import { RequestDetailItemMobile } from './RequestDetailItemMobile';

interface Props {
  items: any;
  hasMoreInfo: boolean;
  isB2B: boolean;
}

function RequestDetailItems({ items, hasMoreInfo, isB2B }: Props) {
  const columns = hasMoreInfo
    ? [
        { name: 'Produkt', width: '100%' },
        {
          name: isB2B ? 'Cena za kus bez DPH' : 'Cena za kus s DPH',
          minWidth: rem(170),
        },
        { name: 'Množstvo', minWidth: rem(100) },
        { name: isB2B ? 'Spolu bez DPH' : 'Spolu s DPH' },
      ]
    : [
        { name: 'Produkt', width: '100%' },
        { name: 'Množstvo', minWidth: rem(120) },
      ];
  const headers =
    columns &&
    columns.map((item: any) => (
      <StyledBasicTableTh
        width={item.width}
        minWidth={item.minWidth}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </StyledBasicTableTh>
    ));

  const itemsRows =
    items &&
    items.map((item: any) =>
      !item.is_meta_item ? (
        <RequestDetailItemRow
          showMoreInfo={hasMoreInfo}
          key={item.good_id}
          item={item}
          isB2B={isB2B}
        />
      ) : null,
    );

  const mobileProductsComponent =
    items &&
    items.map((item: any, i) =>
      !item.is_meta_item ? (
        <RequestDetailItemMobile
          showMoreInfo={hasMoreInfo}
          key={item.good_id}
          item={item}
          isB2B={isB2B}
        />
      ) : null,
    );

  return (
    <Wrapper>
      <DesktopListProductsWrapper>
        <TableWrapper
          tableHasBorder={false}
          tableHasBoxShadow={false}
          noItemsText={__('Nenašli sa žiadne dopytované produkty')}
          headers={headers}
          rows={itemsRows}
        />
      </DesktopListProductsWrapper>
      <MobileListProductsWrapper>
        {mobileProductsComponent}
      </MobileListProductsWrapper>
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const StyledBasicTableTh = styled(BasicTableTh)`
  background-color: inherit;
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  margin-bottom: ${rem(24)};
  animation: ${animateIn} 0.2s ease;
  margin-top: ${rem(32)};

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(56)};
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

export { RequestDetailItems };
